var _metadata, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,442.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9519.1,3555.3c-1255.6-786.7-2450-1697.8-3617.6-2758.2C5237.4,192.3,4366.4-693.9,3788.4-1358.1c-134-153.1-248.8-279.4-256.5-281.4c-7.7-3.8-545.5,411.5-1196.3,922.6L1152.7,209.6L747-117.8C523-297.7,287.6-489.1,220.6-542.7L100-638.4l352.2-356c193.3-195.2,1115.9-1131.2,2051.9-2082.5c934.1-951.3,1705.4-1722.7,1713.1-1713.1c7.7,7.6,61.3,122.5,116.8,254.6c55.5,132.1,201,438.3,323.5,679.5C5557-2077.7,7036.6,27.7,8577.4,1721.7c120.6,132.1,467,488.1,771.3,790.5l551.3,551.3l-124.4,281.4c-68.9,155-126.3,283.3-128.2,285.2C9645.4,3631.9,9588,3597.4,9519.1,3555.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.be27c98b7a88e4ab1eb7a6125d18c0c0.svg";
export { ForwardRef as ReactComponent };